module.exports = __webpack_public_path__ + "img/pickup.45f16f09.png";